export const ADD_CATEGORY = 'ADD_CATEGORY';
export const GET_CATEGORIES = 'GET_CATEGORIES';
export const REMOVE_CATEGORY = 'REMOVE_CATEGORY';

export const REGISTRATION_START = 'REGISTRATION_START';
export const REGISTRATION_SUCCESS = 'REGISTRATION_SUCCESS';
export const REGISTRATION_FAIL = 'REGISTRATION_FAIL';

export const AUTH_SET_PROFILE = 'AUTH_SET_PROFILE';
export const AUTH_START = 'AUTH_START';
export const AUTH_SUCCESS = 'AUTH_SUCCESS';
export const AUTH_FAIL = 'AUTH_FAIL';
export const AUTH_LOGOUT = 'AUTH_LOGOUT';

export const WALMART_GET_ALL_CATEGORIES = 'WALMART_GET_ALL_CATEGORIES';




// WEBPACK FOOTER //
// src/store/actions/actionTypes.js